import random from 'lodash/random';

import { COLORS, DEFAULT_COLOR } from './constants';
import { getMonogram } from './monogram';
import { AvatarPlaceholder, ColorConfig } from './types';

export const getFontSizeByWidth = (width = 125) => {
    switch (true) {
        case width < 40:
            return 12;
        case width < 64:
            return 18;
        case width < 124:
            return 24;
        default:
            return 72;
    }
};

export const getFontWeightByWidth = (width = 125) => {
    return width < 40 ? 500 : undefined;
};

function getAvatarPlaceholderColors(uid?: number): ColorConfig {
    const colorIndex = uid ? uid % COLORS.length : random(0, COLORS.length - 1);
    return COLORS[colorIndex];
}

interface AvatarPlaceholderParams {
    uid?: string;
    name?: string;
}

export const getAvatarPlaceholder = (params?: AvatarPlaceholderParams): AvatarPlaceholder => {
    const [backgroundColor, textColor] = getAvatarPlaceholderColors(Number(params?.uid));

    return {
        abbreviation: getMonogram(params?.name),
        textColor,
        backgroundColor,
    };
};

export const getDefaultAvatarPlaceholder = (name?: string) => {
    const [backgroundColor, textColor] = DEFAULT_COLOR;

    return {
        abbreviation: getMonogram(name),
        textColor,
        backgroundColor,
    };
};
